module.exports = __webpack_public_path__ + "img/shengchan1.jpg";